import React, { useState, useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { IconChevronDown } from "@tabler/icons-react";
import "../../css/sideNav.css";

const SideNav = ({ isOpen, setIsOpen, items }) => {
  const navigate = useNavigate();
  const location = useLocation();
  const [activeKey, setActiveKey] = useState("");
  const [openKeys, setOpenKeys] = useState({});
  const [isMobile, setIsMobile] = useState(window.innerWidth < 768);

  // ✅ Detect mobile screen size dynamically
  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth < 768);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  // ✅ Auto-highlight based on URL path
  useEffect(() => {
    const findKeyByPath = (items, path) => {
      for (let item of items) {
        if (item.path === path) return item.key;
        if (item.children) {
          const child = findKeyByPath(item.children, path);
          if (child) return child;
        }
      }
      return null;
    };
    const currentKey = findKeyByPath(items, location.pathname + location.search);
    if (currentKey) setActiveKey(currentKey);
  }, [location.pathname, location.search, items]);

  // ✅ Handle navigation + Auto-close on mobile
  const handleNavigation = (key, path, onClick) => {
    setActiveKey(key);
    if (onClick) onClick();
    if (path) navigate(path);
    if (isMobile && setIsOpen) setIsOpen(false); // close sidenav on mobile if setter exists
  };

  // ✅ Accordion behavior — only one parent menu open at a time
  const toggleParent = (key) => {
    setOpenKeys((prev) => {
      if (prev[key]) return {};
      return { [key]: true };
    });
  };

  return (
    <div className="custom-sidenav">
      <div className={`sidenav ${isOpen ? "open" : ""}`}>
        <nav>
          {items.map((item) => {
            const isParentOpen = openKeys[item.key];

            return (
              <div key={item.key}>
                <div
                  className={`nav-item parent-item ${activeKey === item.key ? "active" : ""
                    } ${isParentOpen ? "open" : ""}`}
                  onClick={() =>
                    item.children
                      ? toggleParent(item.key)
                      : handleNavigation(item.key, item.path, item.onClick)
                  }
                >
                  {item.icon}
                  <span className="menu-label-text">{item.label}</span>
                  {item.children && (
                    <IconChevronDown
                      className="expansion-icon"
                      size={16}
                      stroke={2}
                    />
                  )}
                </div>

                {/* ✅ Submenu */}
                {item.children && (
                  <div
                    className={`submenu pcu-transition-all ${isParentOpen ? "pcu-opacity-100" : "pcu-opacity-0"}`}
                    style={{
                      maxHeight: isParentOpen ? "1000px" : "0"
                    }}
                  >
                    {item.children.map((child) => (
                      <div
                        key={child.key}
                        className={`nav-item submenu-item ${activeKey === child.key ? "active" : ""
                          }`}
                        onClick={() => handleNavigation(child.key, child.path, child.onClick)}
                      >
                        {child.icon}
                        <span className="menu-label-text">{child.label}</span>
                      </div>
                    ))}
                  </div>
                )}
              </div>
            );
          })}
        </nav>
      </div>
    </div>
  );
};

export default SideNav;
